var _rect, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWhatsappnew = function SvgWhatsappnew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.456 24 .81-3.756a7.974 7.974 0 1 1 2.889 2.716L8.456 24z",
    fill: "#393",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.197 17.376c-.174-.115-.347-.173-.52.058l-.694.925c-.173.115-.289.173-.52.057-.867-.462-2.08-.982-3.12-2.716-.058-.23.057-.346.173-.462l.52-.809c.116-.115.058-.23 0-.346l-.693-1.676c-.174-.462-.347-.405-.52-.405h-.463c-.115 0-.346.058-.577.29-1.272 1.27-.752 3.062.173 4.217.173.232 1.329 2.312 3.814 3.41 1.849.809 2.253.693 2.773.578.636-.058 1.271-.578 1.56-1.098.058-.174.347-.925.116-1.04",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsappnew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsappnew.9a5d8cbf.svg";
export { ForwardRef as ReactComponent };